import { type ReactElement, useState, FormEvent, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../hooks/registerUser";
import { useForm, SubmitHandler } from "react-hook-form";
import { AppDispatch, RootState } from "src/app/store";
import userImage from "../../../assests/Icons/user.svg";
import passwordImage from "../../../assests/Icons/lock.svg";

type LoginFields = {
        FirstName: string;
        LastName: string;
        Password: string;
        ConfirmPassword: string;
}

export default function SignUpForm(): ReactElement {
        const { register, watch, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm<LoginFields>();
        const dispatch = useDispatch<AppDispatch>();
        const { registerUserError, response } = useSelector((state: RootState) => state.registerUser);
        const navigate = useNavigate();
        const location = useLocation();
        const queryString = location.search;
        const queryParams = new URLSearchParams(queryString);
        const token = queryParams.get('token');

        const onSubmit: SubmitHandler<LoginFields> = async (data) => {
                await dispatch(registerUser({ data, token }));
        }

        useEffect(() => {
                if (response !== null) {
                        navigate('/');
                }
                if (registerUserError !== null) {
                        setError("root", {
                                message: registerUserError,
                        })
                }
                if (token == null) {
                        navigate('/');
                }
        }, [registerUserError, response])

        return <>
                <div className="w-full p-6 max-md:max-w-lg mx-auto">
                        <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="mb-8">
                                        <h3 className="text-gray-800 text-3xl font-bold">Register User</h3>
                                </div>
                                <div>
                                        <label className="text-gray-800 text-[15px] mb-2 block">First Name</label>
                                        <div className="relative flex items-center">
                                                <input type="text" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter FirstName" {...register("FirstName", { required: "First Name is required", maxLength: { value: 35, message: "Enter a First Name" }, })} />
                                                <img src={userImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.FirstName && (
                                                <div className="text-red-500">{errors.FirstName.message}</div>
                                        )}
                                </div>
                                <div>
                                        <label className="text-gray-800 text-[15px] mb-2 block">Last Name</label>
                                        <div className="relative flex items-center">
                                                <input type="text" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter LastName" {...register("LastName", { required: "Last Name is required", maxLength: { value: 35, message: "Enter a Last Name" }, })} />
                                                <img src={userImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.LastName && (
                                                <div className="text-red-500">{errors.LastName.message}</div>
                                        )}
                                </div>
                                {/* <div> */}
                                {/*         <label className="text-gray-800 text-[15px] mb-2 block">Email</label> */}
                                {/*         <div className="relative flex items-center"> */}
                                {/*                 <input type="text" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter email" {...register("EmailId", { required: "Email is required", pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Enter a valid Email Address" }, })} /> */}
                                {/*                 <img src={userImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" /> */}
                                {/*         </div> */}
                                {/*         {errors.EmailId && ( */}
                                {/*                 <div className="text-red-500">{errors.EmailId.message}</div> */}
                                {/*         )} */}
                                {/* </div> */}

                                <div className="mt-4">
                                        <label className="text-gray-800 text-[15px] mb-2 block">Password</label>
                                        <div className="relative flex items-center">
                                                <input type="password" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter password" {...register("Password", { required: "Password is required", minLength: { value: 8, message: "Password must be atleast 8 characters" }, })} />
                                                <img src={passwordImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.Password && (
                                                <div className="text-red-500">{errors.Password.message}</div>
                                        )}
                                </div>
                                <div className="mt-4">
                                        <label className="text-gray-800 text-[15px] mb-2 block">Confirm Password</label>
                                        <div className="relative flex items-center">
                                                <input type="password" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter password" {...register("ConfirmPassword", {
                                                        required: "Confirm Password is required", validate: (value: string) => {
                                                                if (watch('Password') !== watch('ConfirmPassword')) {
                                                                        return "The Passwords do not match";
                                                                }
                                                        },
                                                })} />
                                                <img src={passwordImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.ConfirmPassword && (
                                                <div className="text-red-500">{errors.ConfirmPassword.message}</div>
                                        )}
                                </div>
                                <div className="mt-8">
                                        <button disabled={isSubmitting} type="submit" className="w-full py-3 px-4 text-sm tracking-wide rounded-xs text-white bg-blue-600 hover:bg-blue-700 focus:outline-none">
                                                {isSubmitting ? "Registering..." : "Register"}
                                        </button>
                                </div>
                        </form>
                </div>
        </>
}
